import { Component, Input } from '@angular/core';

export type PillVariant = 'default' | 'good' | 'warn' | 'bad' | 'info' | 'muted';

@Component({
    standalone: false,
    selector: 'mkt-ws-pill',
    template: `
<span class="pl" [class]="'pl--' + variant">
    <span class="pl__dot" *ngIf="dot"></span>
    <ng-content></ng-content>
</span>
    `,
    styles: [`
        :host { display: inline-flex; }
        .pl { display: inline-flex; align-items: center; gap: 5px; padding: 1.5px 8px; border-radius: 99px; font-size: 11px; font-weight: 500; border: 1px solid var(--mj-border-default, #e0e0e0); background: var(--mj-bg-page, #f5f5f5); color: var(--mj-text-secondary, #71717a); }
        .pl__dot { width: 5px; height: 5px; border-radius: 99px; background: currentColor; }
        .pl--good { color: var(--mj-color-success-700, #047857); background: var(--mj-color-success-50, #ecfdf5); border-color: var(--mj-color-success-100, #d1fae5); }
        .pl--warn { color: var(--mj-color-warning-700, #b45309); background: var(--mj-color-warning-50, #fffbeb); border-color: var(--mj-color-warning-100, #fde68a); }
        .pl--bad { color: var(--mj-status-error, #be123c); background: var(--mj-color-error-50, #fff1f2); border-color: var(--mj-color-error-100, #fecdd3); }
        .pl--info { color: var(--mj-brand-primary, #6366f1); background: color-mix(in srgb, var(--mj-brand-primary, #6366f1) 8%, transparent); border-color: color-mix(in srgb, var(--mj-brand-primary, #6366f1) 25%, transparent); }
        .pl--muted { color: var(--mj-text-secondary, #71717a); }
    `]
})
export class PillComponent {
    @Input() variant: PillVariant = 'default';
    @Input() dot = false;
}
